<div class="bell-only">
    <lfwms-breadcrumb></lfwms-breadcrumb>
</div>
<div class="detailContainer">
    <div class="header">
        <!-- <lfwms-searchable-entity-search [serviceFactory]="serviceFactory">
        </lfwms-searchable-entity-search> -->
        <div class="panel-heading search-page-header" style="display: flex;
            align-items: center;">
            <span class="lfwms-heading-primary">Fleet Monitoring</span>
            <span class="fixed-span">
                <ng-template>
                    <span>
                        <img class="favourites" pTooltip="Add to Favourites" tooltipPosition="top" />
                    </span>
                </ng-template>
            </span>
        </div>
    </div>
    <div>
        <img src="/assets/images/detail_page_icon.png" pTooltip="List View" tooltipPosition="bottom"
            alt="detail page icon" id="detail_page" (click)="goToList()">
    </div>
    <div id="mapCard" [ngClass]="{ 'expanded': isMapExpanded }">
        <div class="zoomSettingBox">
            <p-button *ngIf="!sidebarVisible" icon="pi pi-angle-right" (onClick)="sidebarVisible = true" class="drawer"
                [style]="{'width':'20px','height':'40px', 'background-color':'#FFFFFF', 'border': '1px solid #CFCFCF', 'border-radius': '4px'}"></p-button>

            <p-button *ngIf="sidebarVisible" icon="pi pi-angle-left" (onClick)="sidebarVisible = false"
                class="drawer-close"
                [style]="{'width':'20px','height':'40px', 'background-color':'#FFFFFF', 'border': '1px solid #CFCFCF', 'border-radius': '4px'}"></p-button>

            <img class="zoomSetting" src="assets/images/svg/fleets/icon_map_setting.svg" (click)="handleSeetings()"
                style="border: 1px solid #CFCFCF; border-radius: 4px;">
            <div *ngIf="showSeetings" id="settingModal">
                <div>Geofences
                    <p-inputSwitch disabled="true" class="p-inputSwitch-lg"></p-inputSwitch>
                </div>
                <div>Traffic Layer
                    <p-inputSwitch disabled="true" class="p-inputSwitch-lg"></p-inputSwitch>
                </div>
                <div>Clustering
                    <p-inputSwitch disabled="true" class="p-inputSwitch-lg"></p-inputSwitch>
                </div>
                <div>Vehicles
                    <p-inputSwitch [(ngModel)]="isVehiclesSwitchChecked" (onChange)="handleVehiclesSwitchChange($event)"
                        class="p-inputSwitch-lg">
                    </p-inputSwitch>
                </div>
            </div>
        </div>
        <div id="vehicleModal" *ngIf="sidebarVisible && showTruckList">
            <div *ngIf="isLoading; else content">
                <i class="pi pi-spin pi-spinner spinner" style="font-size: 2rem"></i>
                <p class="loading">Loading...</p>
            </div>
            <div *ngIf="truckList?.length <= 1" class="fallback-text">
                <p>Couldn't find active trucks</p>
            </div>
            <ng-template #content>
                <div class="vehicleTitle">Vehicle
                    <img (click)="addHeartbeat()" src="assets/images/svg/fleets/icon_truck-front.svg"
                        style="margin-left: 5px;width: 22px;">
                    <span class="vehical">{{this.params.totalShipment}}<img
                            src="assets/images/svg/fleets/icon_truck-side.svg"></span>
                </div>
                <div class="normalDrop">
                    <p-dropdown class="truck-dropdown" placeholder="All" [options]="truckList" filter="true"
                        optionLabel="truckNumber" optionValue="truckXid" [(ngModel)]="selectedTruckNumber"
                        (onChange)="onTruckSelected($event)">
                    </p-dropdown>
                </div>
                <hr>
                <div class="truck-list">
                    <div *ngFor="let truck of params.equipmentAll; let last = last">
                        <ng-container *ngIf="truck.truckNumber !== 'All'">
                            <div class="truck-info">
                                <div class="info"><strong>{{ truck?.truckNumber }}</strong>
                                    <div class="excess-speed" *ngIf="truck.speed && +truck.speed > 80"><i
                                            class="pi pi-exclamation-triangle"
                                            style="margin-left: 5px; margin-right: 5px"></i>{{truck?.speed}} kph</div>
                                    <a class="details-link" (click)="getTruckOverview(truck.truckNumber)"
                                        style="cursor: pointer;">Detail</a>

                                </div>
                                <div class="info"><i class="pi pi-map-marker" style="margin-right: 5px;"></i>{{
                                    truck?.location
                                    }}</div>
                                <div class="info"><img src="assets/images/driver_name.png" alt="driver_icon"
                                        style="margin-right: 5px;">{{ truck?.deviceDriverName }}</div>
                            </div>
                            <hr *ngIf="!last" />
                        </ng-container>
                    </div>
                </div>
            </ng-template>



            <!-- <div *ngIf="contentPartFlag" class="address">{{detailModal?.locationAdress}}</div>
            <div *ngIf="contentPartFlag" class="contentPart">
                <div class="vehicleHead"> <span class="contentPartTitle" style="width: 125px;">Last Reporting Date
                    </span>
                    {{transToLocationTimes(detailModal?.lastReportingDate)}}</div>
                <p>
                    <span class="contentPartTitle">Via</span>
                    <span class="contentPartContent">{{detailModal?.location}}</span>
                </p>
                <hr>
                <p>
                    <span class="contentPartTitle">Travel Duration</span>
                    <span class="contentPartContent">{{detailModal?.arrivalStopTravelDuration ?
                        detailModal.arrivalStopTravelDuration + 'mins' : ''}} </span>
                </p>
                <p>
                    <span class="contentPartTitle">ETA</span>
                    <span class="contentPartContent">{{detailModal.ETATimes}}</span>
                </p>
                <p>
                    <span class="contentPartTitle">Distance </span>
                    <span class="contentPartContent">
                        {{ detailModal?.arrivalStopDistance ? detailModal.arrivalStopDistance + 'km' : '' }}
                    </span>
                </p>
            </div> -->
        </div>




        <div id="vehicleModal" *ngIf="sidebarVisible && !showTruckList">
            <div *ngIf="isSecondaryModalLoading; else content">
                <i class="pi pi-spin pi-spinner spinner" style="font-size: 2rem"></i>
                <p class="loading">Loading...</p>
            </div>

            <ng-template #content>
                <div class="vehicle-details">
                    <div class="vehicleTitle">Vehicle
                        <img (click)="addHeartbeat()" src="assets/images/svg/fleets/icon_truck-front.svg"
                            style="margin-left: 5px;width: 22px;">
                        <span class="selected-truck">{{this.clickedTruck}}<img
                                src="assets/images/svg/fleets/icon_truck-side.svg" class="red-tag-truck"> <img
                                src="assets/images/close_btn.png" alt="close button" class="close_btn"
                                (click)="gobackToTruckList()" style="cursor: pointer;"></span>
                    </div>

                    <hr>
                    <div class="extra-details">
                        <p><strong>{{clickedTruck}}</strong></p>
                        <p>{{ transToLocationTimes(detailModal?.lastReportingDate) | date: "MMM d 'at' h:mm a" }}</p>

                        <a class="link-to-detail" (click)="navigateToDetailPage(clickedTruck)"
                            style="cursor: pointer;">Detail</a>

                        <hr>

                        <div class="row-driver">
                            <div class="col-driver">
                                <strong>Driver</strong>
                            </div>
                            <div class="col-driver">
                                <p>{{truckDetailsForModal?.deviceDriverName}}</p>
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col">
                                <strong>Phone Number</strong>
                                <strong>Shipment ID</strong>
                            </div>
                            <div class="col">
                                <p>{{driverPhoneNumber}}</p>
                                <select class="form-control sr-box">
                                    <option *ngFor="let option of shipmentList" [value]="option.xid">{{
                                        option.xid }}</option>
                                </select>
                            </div>
                        </div>

                        <hr>

                        <div class="row-detail">
                            <div class="col-detail">
                                <strong>Via</strong>
                            </div>
                            <div class="col-detail">
                                <p>{{detailModal?.location}}</p>
                            </div>
                        </div>
                        <br>
                        <div class="row-detail">
                            <div class="col-detail">
                                <strong>Destination</strong>
                            </div>
                            <div class="col-detail">
                                <p>{{detailModal?.locationAdress}}</p>
                            </div>
                        </div>

                        <br>

                        <div class="row">
                            <div class="col">
                                <strong>Distance</strong>
                                <strong>Travel Duration</strong>
                                <strong>ETA</strong>
                                <strong>Speed</strong>
                            </div>

                            <div class="col">
                                <p>{{ detailModal?.arrivalStopDistance ? detailModal.arrivalStopDistance + ' ' + 'km' :
                                    ''
                                    }}
                                </p>
                                <p>{{detailModal?.arrivalStopTravelDuration ?
                                    detailModal.arrivalStopTravelDuration + ' ' + 'mins' : ''}}</p>
                                <p>{{detailModal.ETATimes}}</p>
                                <p *ngIf="+truckDetailsForModal.speed > 80; else normalSpeed" style="color: #B80012;">
                                    <i class="pi pi-exclamation-triangle"
                                        style="color: #B80012; margin-right: 5px;"></i>
                                    {{ truckDetailsForModal.speed }} kph
                                </p>

                                <ng-template #normalSpeed>
                                    <p>{{ truckDetailsForModal.speed }} kph</p>
                                </ng-template>
                            </div>
                        </div>


                        <!-- <div *ngIf="contentPartFlag" class="address">{{detailModal?.locationAdress}}</div>
                <div *ngIf="contentPartFlag" class="contentPart">
                <div class="vehicleHead"> <span class="contentPartTitle" style="width: 125px;">Last Reporting Date
                    </span>
                    {{transToLocationTimes(detailModal?.lastReportingDate)}}</div>
                <p>
                    <span class="contentPartTitle">Via</span>
                    <span class="contentPartContent">{{detailModal?.location}}</span>
                </p>
                <hr>
                <p>
                    <span class="contentPartTitle">Travel Duration</span>
                    <span class="contentPartContent">{{detailModal?.arrivalStopTravelDuration ?
                        detailModal.arrivalStopTravelDuration + 'mins' : ''}} </span>
                </p>
                <p>
                    <span class="contentPartTitle">ETA</span>
                    <span class="contentPartContent">{{detailModal.ETATimes}}</span>
                </p>
                <p>
                    <span class="contentPartTitle">Distance </span>
                    <span class="contentPartContent">
                        {{ detailModal?.arrivalStopDistance ? detailModal.arrivalStopDistance + 'km' : '' }}
                    </span>
                </p>
                </div> -->
                    </div>
                </div>
            </ng-template>

        </div>
        <div class="map" id="fleetMap"></div>
    </div>
</div>